import { memo } from "react";

import { AccordionItem } from "@components/AccordionItem/AccordionItem.data";
import { type ProductHeroAccordionItem } from "@root/tablescape/state";
import { ReviewsAccordionItem } from "@sections/ProductHero/ProductHeroAccordion/ReviewsAccordionItem";

type Props = {
  accordionItems: ProductHeroAccordionItem[];
  onToggle: (index: number) => void;
  openItemIndex: number | null;
  rating: {
    textReadMoreReviews: string;
    textReviews: string;
  };
};

const ProductHeroAccordionViewBase = ({
  accordionItems,
  onToggle,
  openItemIndex,
  rating,
}: Props) => {
  return (
    <>
      {accordionItems.map((item: ProductHeroAccordionItem, index) => {
        switch (item.type) {
          case "richText":
            return (
              <AccordionItem
                content={item.content.content}
                heading={item.content.heading}
                isOpen={index === openItemIndex}
                itemIndex={index}
                key={`${index}-${item.content.heading}`}
                onToggle={onToggle}
              />
            );
          case "reviews":
            return (
              <ReviewsAccordionItem
                isOpen={index === openItemIndex}
                itemIndex={index}
                key={`${index}-reviews`}
                onToggle={onToggle}
                rating={rating}
                reviews={item.reviews}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};

export const ProductHeroAccordionView = memo(ProductHeroAccordionViewBase);
